import styled from 'styled-components';

import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { SmallStyled } from 'approot/shared/styles/typography.style';
import { grey7 } from 'approot/shared/styles/colours.style';

export const ClassroomStudentIdentifier = styled.div`
  ${baseFlexCss}
  gap: ${rem(spacing8)};
  overflow: hidden;
`;

export const ClassroomStudentIdentifierInner = styled.div`
  overflow: hidden;
`;

export const ClassroomStudentIdentifierEmoji = styled.div`
  flex-shrink: 0;
`;

export const ClassroomStudentIdentifierSecondaryContent = styled(SmallStyled)`
  color: ${grey7};
`;
